<template>
    <ul class="collection-share">
      <li class="tt">分享到</li>
      <li class="sinat">
        <a :href="sinaUrl" target="_blank" data-clev="10220259" :data-spm-acode="shareAction" data-spm-click-pm="shareCode:weibo">
          <em class="icon sinat-icon"></em>
        </a>
      </li>
      <li class="weixin" @mouseenter="renderQrcode">
        <a href="javascript:void(0)"><em class="icon weixin-icon"></em></a>
        <div class="wx-code">
          <div class="cort"></div>
          <div class="code-pic">
            <div id="qrcode" class="qrcode"></div>
          </div>
          <p class="wx-tip">分享到微信</p>
        </div>
      </li>
      <li class="qzone">
        <a :href="qzoneUrl" target="_blank" data-clev="10220260" :data-spm-acode="shareAction" data-spm-click-pm="shareCode:qqz">
          <em class="icon qzone-icon"></em>
        </a>
      </li>
    </ul>
  </template>
  
  <script>
  import QRCode from 'qrcodejs2';
  import Utils from '@/utils/Utils';
  import { acodeConfig } from '@/config/spmConfig';
  
  export default {
    name: 'ShareComponent',
    props: {
        from:{
            type: String,
            default: 'video' // video|collection
        },
    },
    computed: {
        qrcodeUrl() {
            if(this.from === 'video'){
                return "/a/" + window.pcArticleInfo?.news_id + "_" + window.pcArticleInfo?.media_id;
            }else{
                return '/collection/' + window.pcArticleInfo?.id
            }
        }
    },
    data() {
      return {
        param: {
          webid: '',
          name: '',
          title: document.title,
          url: window.location.href,
          pic: '',
          content: '',
          sina_appkey: '',
          tencent_appkey: '',
          qrcodeUrl: ''
        },
        mobileHost: Utils.getWapSohuHost(),
        sinaUrl: '',
        qzoneUrl: '',
        shareAction: acodeConfig.shareAction,
        rendered: false
      };
    },
    mounted() {
      this.param.pic = document.querySelector('article img')?.src || '';
      this.param.qrcodeUrl = `${this.mobileHost}${this.qrcodeUrl}/?_trans_=010005_pcwzywxewmsm`;
  
      this.sinaUrl = `http://service.weibo.com/share/share.php?url=${encodeURIComponent(this.param.url)}&title=${encodeURIComponent(this.param.title)}&searchPic=true&pic=${this.param.pic}&appkey=2890110694`;
  
      const qzoneBase = `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(this.param.url)}`;
      this.qzoneUrl = process.env.ISPROD ? qzoneBase : `${qzoneBase}&title=${encodeURIComponent(this.param.title)}&searchPic=true&pics=${this.param.pic}?imageView&thumbnail=550x0&desc=`;
    },
    methods: {
      renderQrcode() {
        if (window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
          window.sohuSpm.sendAction({
            acode: acodeConfig.shareAction,
            clkParam: 'shareCode:wxf'
          });
        }
  
        if (this.rendered) {
          return;
        }
  
        const qrcodeDom = document.querySelectorAll('#qrcode');
        qrcodeDom.forEach(dom => {
          new QRCode(dom, {
            text: this.param.qrcodeUrl,
            width: 90,
            height: 90,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          });
        });
  
        this.rendered = true;
      }
    }
  };
  </script>
  
  <style scoped>
  #qrcode {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    img {
      width: 90px;
      height: 90px;
    }
  }
  .collection-share {
    li {
      margin-left: 0 !important;
      a {
        .icon {
          background-size: initial !important;
        }
      }
    }
  }
  </style>
  